// src/api/partner.js
// What a referral partner can see about their own network. Every endpoint is
// scoped server-side to the partner on the authenticated user.

import client from "./client";

const unwrap = (res) => res.data.data;

const apiError = (err) => {
  const body = err.response?.data;
  const e = new Error(body?.error || "Something went wrong. Try again.");
  e.code = body?.code || "NETWORK";
  e.status = err.response?.status || 0;
  return e;
};

const run = async (promise) => {
  try {
    return unwrap(await promise);
  } catch (err) {
    throw apiError(err);
  }
};

export const getMe = () => run(client.get("/partner/me"));

export const getOverview = () => run(client.get("/partner/overview"));

export const getCodes = () => run(client.get("/partner/codes"));

export const getConsultants = () => run(client.get("/partner/consultants"));

export const getCommission = (params = {}) =>
  run(client.get("/partner/commission", { params }));